import CommenService from '@/service/index.js';
import Service from '../invoice-pro-service.js';
import { errorMessage } from '@/utils/message.js';
export default {
  data() {
    return {
      query: {},
      detail: {},
      invoiceStatus: []
    };
  },
  computed: {
    typeTxt: function () {
      if(this.detail.type === 1) {
        return '电子发票';
      }
    }
  },
  created() {
    this.query = this.$route.query;
    const obj = {
      INVOICE_STATUS: 'invoiceStatus'
    };
    Object.keys(obj).forEach((key) => {
      CommenService.getSelectList(key).then(res => {
        if (res && res.code === '0') {
          this[obj[key]] = [{code: '', value: '全部'}, ...res.data];
        }
      });
    });
    this.getDetail();
  },
  methods: {
    // 获取发票详情
    getDetail(){
      Service.getDetail(this.query.projectId, this.query.bidId, this.query.projectType).then(res => {
        if (res && res.code === '0') {
          this.detail = res.data;
        } else {
          errorMessage(res && res.reason);
        }
      }, (error) => {
        if (error && error.data && error.data.reason) {
          errorMessage(error.data.reason);
        }
      });
    },
    previousStep () {
      this.$router.back();
    }
  }
};
